import moment from 'moment-timezone'

// Shared by the topbar notifications and the requests page

export const MATCH_CHANGE_STATUS = {
    voting: { label: 'Voting', color: 'blue' },
    pending: { label: 'Waiting for approval', color: 'orange' },
    approved: { label: 'Approved', color: 'green' },
    rejected: { label: 'Rejected', color: 'red' },
    declined: { label: 'Declined by a team', color: 'red' },
    expired: { label: 'Expired', color: 'grey' },
    cancelled: { label: 'Cancelled by the team', color: 'blue-grey' }
}

export const POSTPONEMENT_STATUS = {
    pending: { label: 'Waiting for approval', color: 'orange' },
    approved: { label: 'Approved', color: 'green' },
    rejected: { label: 'Rejected', color: 'red' },
    cancelled: { label: 'Cancelled by the team', color: 'blue-grey' }
}

export function formatMatchDate(date) {
    return date ? moment(date).tz('Europe/Athens').format('ddd DD/MM/YYYY HH:mm') : 'No date'
}

export function formatAgo(date) {
    return date ? moment(date).fromNow() : ''
}

// "A - B"
export function slotTeams(slot) {
    return `${slot.team1.name} - ${slot.team2.name}`
}

// the vote of a team: yes / no / not yet
export function voteLabel(vote) {
    if (vote.approved === true) return 'Yes'
    if (vote.approved === false) return 'No'
    return 'Not voted'
}

export function voteColor(vote) {
    if (vote.approved === true) return 'green'
    if (vote.approved === false) return 'red'
    return 'grey'
}

export function errorMessage(error) {
    return (error && error.response && error.response.data && error.response.data.message) || 'Something went wrong'
}
